import Button from '../componenet/Button';
import {
  FaLightbulb,
  FaGraduationCap,
  FaUsers,
  FaBriefcase,
  FaUserSecret,
  FaUserSlash
} from 'react-icons/fa6';
import BenefitCard from '../componenet/cards/BenefitCard';
import AfterJoinCards from '../componenet/cards/AfterJoinCard';
import afterjoin3 from "../assets/afterjoin3.png";
import afterjoin2 from "../assets/afterjoin2.png";
import afterjoin1 from "../assets/afterjoin1.png";
const benefits = [
    {
      icon: FaLightbulb,
      title: 'Being an expert is not necessary.',
      description: 'Finding successful goods is about identifying a distinct value zone and using your new AI tools to create a high-quality product, not about having a lot of experience or a lifetime of work.',
    },
    {
      icon: FaUserSecret,
      title: "You don't have to reveal your identity.",
      description: 'You may create and market a digital product with Monetise without ever revealing your identity. ',
    },
    {
      icon: FaGraduationCap,
      title: "It's not necessary to have prior online sales experience.",
      description: 'The purpose of the Digital Builder Blueprint is to assist you in creating and distributing a product if you have never done it before. Everything is neatly contained within one ecosystem, and a step-by-step guide guides you through the process. ',
    }, 
    {
      icon: FaUsers,
      title: "You don't require a crowd.",
      description: "Joining Monetise will give you immediate access to a sizable and receptive audience that is ready to purchase your goods and doesn't need persuasion.",
    },
  ];

const steps = [
  {
    image: afterjoin1,
    title: 'Use AI to build your digital product.',
    description:
      'From choosing the most lucrative product to writing the screenplay and creating all the deliverables, our AI system will assess consumer demand and combine it with your preferences to create your digital product from the ground up.',
  },
  {
    image: afterjoin2,
    title: 'Use the $4 million/month Marketplace to generate your first sales.',
    description:
      "We will host your product on Whop's Marketplace so that those who are already interested in purchasing your solution may see it. (+$4M/month, average profits per user of $9k/month) made by users from the Market Place",
  },
  {
    image: afterjoin3,
    title: 'Sell as you sleep and scale endlessly.',
    description:
      'Our artificial intelligence system will create all the marketing collateral you require to advertise your digital product through various distribution channels, hence increasing your earnings eternally.',
  },
]; 

const HeroSection = ({handleClick}) => {

  return (
    <div className="max-w-7xl mx-auto py-10 px-4 md:px-10 text-white w-full overflow-hidden" id='home'>

        <div className='flex flex-col py-10 items-center text-center'>  
            <div data-aos="fade-up" className="text-3xl md:text-6xl font-semibold max-w-4xl">
              We Help Brands Get Seen, Heard, and Chosen.            
            </div>

            <div data-aos="fade-up" data-aos-delay="200" className="text-lg md:text-3xl my-8 max-w-2xl text-gray-400">
              From viral social media to clean websites, we help brands grow — with strategy, consistency, and sharp execution.
            </div>

            <div data-aos="zoom-in" data-aos-delay="400" className="py-10">
              <Button variant="solid" onClick={handleClick}>
                  GET A CUSTOM QUOTE
              </Button>
            </div>

            <div data-aos="fade-up" data-aos-delay="600" className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 text-sm text-gray-500">
                <div className="flex items-center gap-2 justify-center">
                <FaBriefcase />
                No Experience
                </div>
                <div className="flex items-center gap-2 justify-center">
                <FaUserSecret />
                No Showing Your Face
                </div>
                <div className="flex items-center gap-2 justify-center">
                <FaUserSlash />
                No Audience
                </div>
            </div> 
        </div>


        {/* <div className='flex flex-col items-center py-10 text-center'>  
            <div className="text-2xl md:text-5xl  my-5 max-w-3xl ">
                Put an end to observing others earn money online.
            </div>
            <div className="text-lg md:text-xl my-4 max-w-2xl text-gray-400">
                Until a few months ago, only people with years of experience in a particular field could create successful digital products.
            </div>
            <div>Now,<strong> our AI System can do everything for you.</strong></div>
        </div>

        <div className='flex flex-col py-10 items-center text-center max-w-6xl mx-auto'>  
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 py-10 text-start '>
                {benefits.map((benefit, index) => (
                    <BenefitCard
                    key={index}
                    icon={benefit.icon}
                    title={benefit.title}
                    description={benefit.description}
                    />
                ))}
            </div>
            <div className='py-10'>    
              <Button variant="solid" onClick={handleClick}>
                  GET A CUSTOM QUOTE
              </Button>
            </div>
        </div> 

        <div className='flex flex-col py-10 items-center text-center'>
          <AfterJoinCards
            steps={steps}
          />  
        </div>    */}
    </div>
  );
};

export default HeroSection